document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.coord-btn').forEach(button => {
    button.addEventListener('click', () => {
      const coordValue = button.getAttribute('data-coord');
      const targetSection = document.querySelector(`section[data-coord="${coordValue}"]`);
      
      if (targetSection) {
        const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: targetPosition - 64,
          behavior: 'smooth'
        });
      }
    });
  });

  const backToMenuBtn = document.createElement('button');
  backToMenuBtn.innerText = 'メニューに戻る';
  backToMenuBtn.className = 'back-to-menu-btn';
  document.body.appendChild(backToMenuBtn);

  window.addEventListener('scroll', () => {
    const menuSection = document.querySelector('.coord-menu');
    if (!menuSection) return;

    const menuBottom = menuSection.getBoundingClientRect().bottom + window.scrollY;
    if (window.scrollY > menuBottom) {
      backToMenuBtn.classList.add('is-show');
    } else {
      backToMenuBtn.classList.remove('is-show');
    }
  });

  backToMenuBtn.addEventListener('click', () => {
    const menuSection = document.querySelector('.coord-menu');
    if (menuSection) {
      const targetPosition = menuSection.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: targetPosition - 64,
        behavior: 'smooth'
      });
    }
  });

});